import { render } from "./FolderFile.vue?vue&type=template&id=721cb704&scoped=true"
import script from "./FolderFile.vue?vue&type=script&lang=js"
export * from "./FolderFile.vue?vue&type=script&lang=js"

import "./FolderFile.vue?vue&type=style&index=0&id=721cb704&scoped=true&lang=css"

import exportComponent from "/usr/local/share/application/bug-finder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721cb704"]])

export default __exports__